import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';
import ExecutiveSummary from 'models/ExecutiveSummary';

const EXECUTIVE_SUMMARY_TAG = 'ExecutiveSummary';

// API module for executive summary
export const executiveSummaryApi = createApi({
  reducerPath: 'executiveSummaryApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/executive-summaries/',
  }),
  tagTypes: [EXECUTIVE_SUMMARY_TAG],
  endpoints: builder => ({
    getExecutiveSummary: builder.query({
      query: ({ projectId, stepSlug }) => ({
        params: { project: projectId, step: stepSlug },
      }),
      providesTags: [EXECUTIVE_SUMMARY_TAG],
      // Return only the first element of the data array in the response
      // and attach the content type
      transformResponse: response => {
        const executiveSummary = response && response[0];
        if (executiveSummary) {
          return new ExecutiveSummary(executiveSummary);
        }
        return null;
      },
    }),
    updateExecutiveSummary: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${id}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [EXECUTIVE_SUMMARY_TAG],
    }),
    uploadExecutiveSummaryImage: builder.mutation({
      query: ({ id, field, image }) => {
        const formData = new FormData();
        formData.append('id', id);
        formData.append(field, image);

        return {
          url: `${id}/`,
          method: 'PATCH',
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        };
      },
      invalidatesTags: [EXECUTIVE_SUMMARY_TAG],
    }),
  }),
});

export const {
  useGetExecutiveSummaryQuery,
  useUpdateExecutiveSummaryMutation,
  useUploadExecutiveSummaryImageMutation,
} = executiveSummaryApi;
